export const mapRegionDicts = {
  'norte': ['AC', 'AP', 'AM', 'PA', 'RO', 'RR', 'TO'],
  'nordeste': ['AL', 'BA', 'CE', 'MA', 'PB', 'PE', 'PI', 'RN', 'SE'],
  'centro-oeste': ['DF', 'GO', 'MT', 'MS'],
  'sudeste': ['ES', 'MG', 'RJ', 'SP'],
  'sul': ['PR', 'RS', 'SC']
}

export const regionScales = {
  'Norte': 1300,
  'Nordeste': 1680,
  'Centro-Oeste': 1800,
  'Sudeste': 2500,
  'Sul': 2500
}